const ACTIVATE_MODAL = "ACTIVATE_MODAL";
const DISMISS_MODAL = "DISMISS_MODAL";

export default { ACTIVATE_MODAL, DISMISS_MODAL };
